import React, { useState } from 'react';
import { Table, Button, Input, Popconfirm, Space, Card, Select } from 'antd';
import { PlusOutlined, DeleteOutlined } from '@ant-design/icons';
const EmployeesList = ({
  setDataSource,
  dataSource,
  t,
  employee,
  form,
  isLoadingPayroll,
}) => {
  const [count, setCount] = useState(0);
  const columns = [
    {
      title: t.Employee,
      dataIndex: 'employee',
      render: (text, record, index) => (
        <Select
          placeholder={t.Employee}
          style={{ width: '100%' }}
          value={record.employee}
          popupMatchSelectWidth={false}
          options={employee?.map((item) => ({
            value: item?.employee,
            label: item?.employee,
            option: item,
            disabled: dataSource?.find((i) => i?.employee === item?.employee),
          }))}
          onChange={(value, option) => {
            const newDataSource = [...dataSource];
            newDataSource[index] = {
              ...newDataSource[index],
              employee: value,
              employee_name: option?.option?.employee_name,
              department: option?.option?.department,
              designation: option?.option?.designation,
            };
            setDataSource(newDataSource);
          }}
        />
      ),
    },
    {
      title: t.employeeName,
      dataIndex: 'employee_name',
      render: (text, record, index) => (
        <Input
          placeholder={t.employeeName}
          style={{ width: '100%' }}
          value={record.employee_name}
          disabled
        />
      ),
    },
    {
      title: t.department,
      dataIndex: 'department',
      render: (text, record, index) => (
        <Input
          placeholder={t.department}
          style={{ width: '100%' }}
          value={record.department}
          disabled
        />
      ),
    },
    {
      title: t.designation,
      dataIndex: 'designation',
      render: (text, record, index) => (
        <Input
          placeholder={t.designation}
          style={{ width: '100%' }}
          value={record.designation}
          disabled
        />
      ),
    },
    // {
    //   title: t.sanctionedAmount,
    //   dataIndex: 'sanctioned_amount',
    //   render: (text, record, index) => (
    //     <Input
    //       placeholder={t.sanctionedAmount}
    //       style={{ width: '100%' }}
    //       value={record.sanctioned_amount}
    //       type="number"
    //       min={0}
    //       onChange={(e) => {
    //         const newDataSource = [...dataSource];
    //         newDataSource[index] = {
    //           ...newDataSource[index],
    //           sanctioned_amount: e.target.value,
    //         };
    //         setDataSource(newDataSource);
    //       }}
    //     />
    //   ),
    // },
    {
      title: t.action,
      key: 'action',
      render: (text, record, index) => (
        <Space>
          <Popconfirm
            title={t.confirmDelete}
            onConfirm={() => handleDelete(record.key)}
          >
            <Button
              type="primary"
              danger
              icon={<DeleteOutlined />}
              size="small"
            />
          </Popconfirm>
        </Space>
      ),
    },
  ];

  const handleAdd = () => {
    const newData = {
      key: count,
    };
    setDataSource((prevDataSource) => [...prevDataSource, newData]);
    setCount(count + 1);
  };

  const handleDelete = (key) => {
    const newDataSource = dataSource.filter((item) => item.key !== key);
    setDataSource(newDataSource);
  };

  return (
    <Card>
      <Table
        className="table_custom"
        dataSource={dataSource}
        columns={columns}
        loading={isLoadingPayroll}
        pagination={{
          hideOnSinglePage: true,
        }}
        scroll={{ x: 'max-content' }}
        // className="table"
        rowKey="key"
      />
      <Button
        onClick={handleAdd}
        type="primary"
        ghost
        style={{ marginTop: '20px', borderRadius: '6px' }}
        icon={<PlusOutlined />}
        size="small"
      >
        {t.addRow}
      </Button>
    </Card>
  );
};

export default EmployeesList;
